<template>
	<div>
        <app-header></app-header>
        <v-container fluid grid-list-xl mt-5>
            <v-layout row wrap justify-center>
                <v-flex xs12 md10 lg7 class="col-height-auto">
                    <!-- <p class="font-16 fw-400">{{$t('kyc.rules.identity.required')}}</p> -->
                    <v-form ref="kycForm" v-model="kycFormValid">
                    	<v-card class="mt-3">
                    		<div class="pa-3">
                    			<p class="mt-4 font-20 fw-400">{{$t('kyc.identity')}}</p>
		                        <v-select
		                            v-model="kycForm.identity"
		                            :label="$t('kyc.identity')"
		                            :items="identitySelect"
		                            :rules="identityRules"
		                            item-text="label"
		                            item-value="value"
		                            required>
		                        </v-select>
		                        <p class="mt-4 font-20 fw-400">{{ $t('kyc.documentIssuingCountry') }}</p>
								<v-select
								    v-model="kycForm.country"
								    :label="$t('kyc.country')"
								    :items="countrySelect"
								    :rules="countryRules"
								    item-text="label"
								    item-value="value"
								    required>
								</v-select>
								<p class="mt-4 font-20 fw-400">{{ $t('kyc.proofOfPermanentAddress') }}</p>
								<v-select
								    v-model="kycForm.proofOfPermanentAddress"
								    :label="$t('kyc.proofOfPermanentAddress')"
								    :items="proofOfPermanentAddressSelect"
								    :rules="proofOfPermanentAddressRules"
								    item-text="label"
								    item-value="value"
								    required>
								</v-select>
                    		</div>
                    	</v-card>
                    	<v-card class="mt-3">
                    		<div class="pa-3">
                    			<p class="mt-4 font-20 fw-400">{{ $t('kyc.basicInformation') }}</p>
                    			<v-flex>
                    				<v-text-field v-model="user.userName" :label="$t('kyc.username')" readonly disabled></v-text-field>
                    				<v-text-field v-model="user.regEmail" label="Email" readonly disabled></v-text-field>
                    				<v-text-field v-model="kycForm.firstName" :rules="firstNameRules" :label="$t('kyc.firstName')" required></v-text-field>
                    				<v-text-field v-model="kycForm.middleName" :label="$t('kyc.middleName')"></v-text-field>
                    				<v-text-field v-model="kycForm.lastName" :rules="lastNameRules" :label="$t('kyc.lastName')" required></v-text-field>
                    				<v-text-field v-model="kycForm.number" :rules="numberRules" :label="$t('kyc.documentNumber')" required></v-text-field>
                    				<v-dialog ref="birthdayDialog" v-model="birthdayModal" lazy full-width width="290px">
								  	   	<v-text-field slot="activator" v-model="kycForm.birthday" :rules="birthdayRules" :label="$t('kyc.birthday')" readonly clearable required></v-text-field>
										<v-date-picker header-color="primary" color="primary" v-model="birthdayFormatted" :max="new Date().toISOString().substr(0, 10)" @input="birthdayModal = false"></v-date-picker>
								    </v-dialog>
								    <v-select
								    	v-model="kycForm.gender"
									    :label="$t('kyc.gender.gender')"
									    :items="genderSelect"
									    item-text="label"
									    item-value="value"
									    required>
									</v-select>
                    			</v-flex>
                    		</div>
                    	</v-card>
                    	<v-card class="mt-4">
                			<v-layout wrap class="pa-3">
                				<v-flex xs12 lg12>
                					<p class="mt-4 font-20 fw-400">{{ $t('kyc.documentFront') }}</p>
                				</v-flex>
                				<v-flex xs12 lg12 v-show="documentImageFrontUrl == null">
                					<Upload type="drag" enctype="multipart/form-data"
		                                class="black--text"
		                                name="upfile"
		                                :action="uploadUrl"
		                                :headers="headers"
	                            		:with-credentials=true
		                                :before-upload="documentImageFrontBeforeUpload">
		                                <Icon type="ios-cloud-upload" size="50" class="primary--text"></Icon>
		                                <p v-if="documentImageFrontFile != null">{{$t("uploadMaterial.uploadFile")}}: {{ documentImageFrontFile.name }}</p>
		                                <p v-else>{{$t("uploadMaterial.uploadHint")}}</p>
		                        	</Upload>
		                        	<v-progress-linear v-show="isShowDocumentImageFrontUploading" color="primary" :indeterminate="true"></v-progress-linear>
                				</v-flex>
                				<v-flex xs12 lg12 v-show="documentImageFrontUrl != null">
                					<div class="text-xs-center">
                						<img :src="documentImageFrontUrl" />
                					</div>
		                        	<div class="right">
		                        		<v-btn outline class="right primary--text mt-3" @click="clearDocumentImageFrontFile">
				                            {{$t("common.clear")}}
				                        </v-btn>
		                        	</div>
                				</v-flex>
                			</v-layout>
                    	</v-card>
                        <v-card class="mt-4">
                        	<v-layout wrap class="pa-3">
                				<v-flex xs12 lg12>
                					<p class="mt-4 font-20 fw-400">{{ $t('kyc.documentBack') }}</p>
                				</v-flex>
                				<v-flex xs12 lg12 v-show="documentImageBackUrl == null">
                					<Upload type="drag" enctype="multipart/form-data"
		                                class="black--text"
		                                name="upfile"
		                                :action="uploadUrl"
		                                :headers="headers"
	                            		:with-credentials=true
		                                :before-upload="documentImageBackBeforeUpload">
		                                <Icon type="ios-cloud-upload" size="50" class="primary--text"></Icon>
		                                <p v-if="documentImageBackFile != null">{{$t("uploadMaterial.uploadFile")}}: {{ documentImageBackFile.name }}</p>
		                                <p v-else>{{$t("uploadMaterial.uploadHint")}}</p>
		                        	</Upload>
		                        	<v-progress-linear v-show="isShowDocumentImageBackUploading" color="primary" :indeterminate="true"></v-progress-linear>
                				</v-flex>
                				<v-flex xs12 lg12 v-show="documentImageBackUrl != null">
                					<div class="text-xs-center">
                						<img :src="documentImageBackUrl" />
                					</div>
		                        	<div class="right">
		                        		<v-btn outline class="right primary--text mt-3" @click="clearDocumentImageBackFile">
				                            {{$t("common.clear")}}
				                        </v-btn>
		                        	</div>
                				</v-flex>
                			</v-layout>
                        </v-card>
                        <v-card class="mt-4">
                        	<v-layout wrap class="pa-3">
                				<v-flex xs12 lg12>
                					<p class="mt-4 font-20 fw-400">{{ $t('kyc.proofOfBill') }}</p>
                				</v-flex>
                				<v-flex xs12 lg12 v-show="proofImageUrl == null">
                					<Upload type="drag" enctype="multipart/form-data"
		                                class="black--text"
		                                name="upfile"
		                                :action="uploadUrl"
		                                :headers="headers"
	                            		:with-credentials=true
		                                :before-upload="proofImageBeforeUpload">
		                                <Icon type="ios-cloud-upload" size="50" class="primary--text"></Icon>
		                                <p v-if="proofImageFile != null">{{$t("uploadMaterial.uploadFile")}}: {{ proofImageFile.name }}</p>
		                                <p v-else>{{$t("uploadMaterial.uploadHint")}}</p>
		                        	</Upload>
		                        	<v-progress-linear v-show="isShowProofImageUploading" color="primary" :indeterminate="true"></v-progress-linear>
                				</v-flex>
                				<v-flex xs12 lg12 v-show="proofImageUrl != null">
                					<div class="text-xs-center">
                						<img :src="proofImageUrl" />
                					</div>
		                        	<div class="right">
		                        		<v-btn outline class="right primary--text mt-3" @click="clearProofImageFile">
				                            {{$t("common.clear")}}
				                        </v-btn>
		                        	</div>
                				</v-flex>
                			</v-layout>
                        </v-card>
                        <v-card class="mt-3">
                        	<div class="pa-3">
                        		<p class="mt-4 font-20 fw-400">{{ $t('kyc.selfieWithPhotoIDAndNote') }}</p>
		                        <v-layout align-center justify-center>
		                        	<v-flex xs12 lg6>
		                        		<div class="text-xs-center">
	                						<img src="https://images.iob.community/SIP-test/material/KYC/resource/selfie-example.jpg" />
	                					</div>
			                        </v-flex>
			                        <v-flex xs12 lg6>
			                        	<p class="font-14 fw-400">{{ $t('kyc.selfieMessage') }}</p>
			                        	<ul class="font-14 fw-400">
			                        		<li>{{ $t('kyc.selfieList1') }}</li>
											<li>{{ $t('kyc.selfieList2') }}</li>
											<li>{{ $t('kyc.selfieList3') }}</li>
											<li>{{ $t('kyc.selfieList4') }}</li>
											<li>{{ $t('kyc.selfieList5') }}</li>
			                        	</ul>
			                        </v-flex>
		                        </v-layout>
		                        <v-layout wrap align-center>
		                        	<v-flex xs12 lg12 v-show="selfieImageUrl == null">
			                        	<Upload type="drag" enctype="multipart/form-data"
			                        		name="upfile"
			                                class="black--text"
			                                :action="uploadUrl"
			                                :headers="headers"
	                            			:with-credentials=true
	                            			:before-upload="selfieImageBeforeUpload">
			                                <Icon type="ios-cloud-upload" size="50" class="primary--text"></Icon>
			                                <p v-if="selfieImageFile != null">{{$t("uploadMaterial.uploadFile")}}: {{ selfieImageFile.name }}</p>
			                                <p v-else>{{$t("uploadMaterial.uploadHint")}}</p>
			                        	</Upload>
		                        		<v-progress-linear v-show="isShowSelfieImageUploading" color="primary" :indeterminate="true"></v-progress-linear>
			                        </v-flex>
			                        <v-flex xs12 lg12 v-show="selfieImageUrl != null">
			                        	<div class="text-xs-center">
	                						<img :src="selfieImageUrl" />
	                					</div>
			                        	<div class="right">
			                        		<v-btn outline class="right primary--text mt-3" @click="clearSelfieImageFile">
					                            {{$t("common.clear")}}
					                        </v-btn>
			                        	</div>
			                        </v-flex>
		                        </v-layout>
                        	</div>
                        </v-card>
                        <v-btn outline class="primary--text right mt-5 mb-5" :loading="submitLoading" @click="submitUserKycHandle">
                            {{$t("common.submit")}}
                        </v-btn>
                    </v-form>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<style>
    
</style>
<script>
	import Vue from 'vue'
	import { mapGetters } from "vuex";
    import config from '../../config.js'
    export default {
        data(){
            return{
                file: null,                     // 上传的文件
                uploadLoading: false,           // 上传加载中,
                submitLoading: false,			// 提交表单加载中
                kycFormValid: true,					
                birthdayModal: false,
                uploadUrl: '',
                //https://images.iob.community/SIP-test/material/KYC/user/20190311/louis/1552276074007.selfieImage.louis.jpg
                /**************************************************************/
                documentImageFrontFile: null,
                documentImageFrontUrl: null,
                isShowDocumentImageFrontUploading: false,
                /**************************************************************/
                documentImageBackFile: null,
                documentImageBackUrl: null,
                isShowDocumentImageBackUploading: false,
                /**************************************************************/
                proofImageFile: null,
                proofImageUrl: null,
                isShowProofImageUploading: false,
                /**************************************************************/
                selfieImageFile: null,
                selfieImageUrl: null,
                isShowSelfieImageUploading: false,
                /**************************************************************/
                headers: {//设置请求头
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
                },
                firstNameRules: [
                	v => !!v || this.$t('kyc.rules.required.required')
                ],
                lastNameRules: [
                	v => !!v || this.$t('kyc.rules.required.required')
                ],
                numberRules: [
                	v => !!v || this.$t('kyc.rules.required.required')
                ],
                birthdayRules: [
                	v => !!v || this.$t('kyc.rules.required.required')
                ],
                birthdayFormatted: null,
                kycForm: {
                	userId: this.$store.getters.user.userId,
                	identity: null,
                	firstName: null,
                	middleName: null,
                	lastName: null,
                	number: null,
                    birthday: this.formatBirthday(this.birthdayFormatted),
                    gender: 'M',
                    documentImageFrontUrl: null,
                    documentImageBackUrl: null,
                    proofImageUrl: null,
                    selfieImageUrl: null,
                },
                identitySelect: [
                    {label: this.$t('kyc.identitySelect.passport'), value: 'PASSPORT' },
                    {label: this.$t('kyc.identitySelect.idCard'), value: 'IDCARD' },
                    {label: this.$t('kyc.identitySelect.driverLicence'), value: 'DRIVERLICENCE' }
                ],
                genderSelect: [
                	{label: this.$t('kyc.gender.male'), value: 'M' },
                	{label: this.$t('kyc.gender.female'), value: 'F' },
                ],
				countrySelect:[
					{label: 'Albania', value: 'Albania'},
					{label: 'Algeria', value: 'Algeria'},
					{label: 'American Samoa', value: 'American Samoa'},
					{label: 'Andorre', value: 'Andorre'},
					{label: 'Angola', value: 'Angola'},
					{label: 'Anguilla', value: 'Anguilla'},
					{label: 'Antarctica', value: 'Antarctica'},
					{label: 'Antigua and Barbuda', value: 'Antigua and Barbuda'},
					{label: 'Argentina', value: 'Argentina'},
					{label: 'Armenia', value: 'Armenia'},
					{label: 'Aruba', value: 'Aruba'},
					{label: 'Australia', value: 'Australia'},
					{label: 'Austria', value: 'Austria'},
					{label: 'Azerbaijan', value: 'Azerbaijan'},
					{label: 'Bahamas', value: 'Bahamas'},
					{label: 'Bahrain', value: 'Bahrain'},
					{label: 'Bangladesh', value: 'Bangladesh'},
					{label: 'Barbados', value: 'Barbados'},
					{label: 'Belarus', value: 'Belarus'},
					{label: 'Belgium', value: 'Belgium'},
					{label: 'Belize', value: 'Belize'},
					{label: 'Benin', value: 'Benin'},
					{label: 'Bermuda', value: 'Bermuda'},
					{label: 'Bhutan', value: 'Bhutan'},
					{label: 'Bolivia', value: 'Bolivia'},
					{label: 'Bonaire, Sint Eustatius and Saba', value: 'Bonaire, Sint Eustatius and Saba'},
					{label: 'Botswana', value: 'Botswana'},
					{label: 'Bouvet Island', value: 'Bouvet Island'},
					{label: 'Brazil', value: 'Brazil'},
					{label: 'British Indian Ocean Territory', value: 'British Indian Ocean Territory'},
					{label: 'British Virgin Islands', value: 'British Virgin Islands'},
					{label: 'Brunei', value: 'Brunei'},
					{label: 'Bulgaria', value: 'Bulgaria'},
					{label: 'Burkina Faso', value: 'Burkina Faso'},
					{label: 'Burundi', value: 'Burundi'},
					{label: 'Cambodia', value: 'Cambodia'},
					{label: 'Cameroon', value: 'Cameroon'},
					{label: 'Canada', value: 'Canada'},
					{label: 'Cape Verde', value: 'Cape Verde'},
					{label: 'Cayman Islands', value: 'Cayman Islands'},
					{label: 'Central African Republic', value: 'Central African Republic'},
					{label: 'Chad', value: 'Chad'},
					{label: 'Chile', value: 'Chile'},
					{label: 'China', value: 'China'},
					{label: 'Christmas Island', value: 'Christmas Island'},
					{label: 'Cocos (Keeling) Islands', value: 'Cocos (Keeling) Islands'},
					{label: 'Colombia', value: 'Colombia'},
					{label: 'Comoros', value: 'Comoros'},
					{label: 'Congo', value: 'Congo'},
					{label: 'Congo (Dem. Rep.)', value: 'Congo (Dem. Rep.)'},
					{label: 'Cook Islands', value: 'Cook Islands'},
					{label: 'Costa Rica', value: 'Costa Rica'},
					{label: 'Croatia', value: 'Croatia'},
					{label: 'Cuba', value: 'Cuba'},
					{label: 'Curaçao', value: 'Curaçao'},
					{label: 'Cyprus', value: 'Cyprus'},
					{label: 'Czech Republic', value: 'Czech Republic'},
					{label: "Côte D'Ivoire", value: "Côte D'Ivoire"},
					{label: 'Denmark', value: 'Denmark'},
					{label: 'Djibouti', value: 'Djibouti'},
					{label: 'Dominica', value: 'Dominica'},
					{label: 'Dominican Republic', value: 'Dominican Republic'},
					{label: 'East Timor', value: 'East Timor'},
					{label: 'Ecuador', value: 'Ecuador'},
					{label: 'Egypt', value: 'Egypt'},
					{label: 'El Salvador', value: 'El Salvador'},
					{label: 'Equatorial Guinea', value: 'Equatorial Guinea'},
					{label: 'Eritrea', value: 'Eritrea'},
					{label: 'Estonia', value: 'Estonia'},
					{label: 'Ethiopia', value: 'Ethiopia'},
					{label: 'Falkland Islands', value: 'Falkland Islands'},
					{label: 'Faroe Islands', value: 'Faroe Islands'},
					{label: 'Fiji', value: 'Fiji'},
					{label: 'Finland', value: 'Finland'},
					{label: 'France', value: 'France'},
					{label: 'French Guiana', value: 'French Guiana'},
					{label: 'French Polynesia', value: 'French Polynesia'},
					{label: 'French Southern Territories', value: 'French Southern Territories'},
					{label: 'Gabon', value: 'Gabon'},
					{label: 'Gambia', value: 'Gambia'},
					{label: 'Georgia', value: 'Georgia'},
					{label: 'Germany', value: 'Germany'},
					{label: 'Ghana', value: 'Ghana'},
					{label: 'Gibraltar', value: 'Gibraltar'},
					{label: 'Greece', value: 'Greece'},
					{label: 'Greenland', value: 'Greenland'},
					{label: 'Grenada', value: 'Grenada'},
					{label: 'Guadeloupe', value: 'Guadeloupe'},
					{label: 'Guam', value: 'Guam'},
					{label: 'Guatemala', value: 'Guatemala'},
					{label: 'Guernsey and Alderney', value: 'Guernsey and Alderney'},
					{label: 'Guinea', value: 'Guinea'},
					{label: 'Guinea-Bissau', value: 'Guinea-Bissau'},
					{label: 'Haiti', value: 'Haiti'},
					{label: 'Heard and McDonald Islands', value: 'Heard and McDonald Islands'},
					{label: 'Honduras', value: 'Honduras'},
					{label: 'Hong Kong', value: 'Hong Kong'},
					{label: 'Hungary', value: 'Hungary'},
					{label: 'Iceland', value: 'Iceland'},
					{label: 'India', value: 'India'},
					{label: 'Indonesia', value: 'Indonesia'},
					{label: 'Ireland', value: 'Ireland'},
					{label: 'Isle of Man', value: 'Isle of Man'},
					{label: 'Israel', value: 'Israel'},
					{label: 'Italy', value: 'Italy'},
					{label: 'Jamaica', value: 'Jamaica'},
					{label: 'Japan', value: 'Japan'},
					{label: 'Jersey', value: 'Jersey'},
					{label: 'Jordan', value: 'Jordan'},
					{label: 'Kazakhstan', value: 'Kazakhstan'},
					{label: 'Kenya', value: 'Kenya'},
					{label: 'Kiribati', value: 'Kiribati'},
					{label: 'Korea (South)', value: 'Korea (South)'},
					{label: 'Kosovo', value: 'Kosovo'},
					{label: 'Kuwait', value: 'Kuwait'},
					{label: 'Kyrgyzstan', value: 'Kyrgyzstan'},
					{label: 'Laos', value: 'Laos'},
					{label: 'Latvia', value: 'Latvia'},
					{label: 'Lebanon', value: 'Lebanon'},
					{label: 'Lesotho', value: 'Lesotho'},
					{label: 'Liberia', value: 'Liberia'},
					{label: 'Libya', value: 'Libya'},
					{label: 'Liechtenstein', value: 'Liechtenstein'},
					{label: 'Lithuania', value: 'Lithuania'},
					{label: 'Luxembourg', value: 'Luxembourg'},
					{label: 'Macao', value: 'Macao'},
					{label: 'Macedonia', value: 'Macedonia'},
					{label: 'Madagascar', value: 'Madagascar'},
					{label: 'Malawi', value: 'Malawi'},
					{label: 'Malaysia', value: 'Malaysia'},
					{label: 'Maldives', value: 'Maldives'},
					{label: 'Mali', value: 'Mali'},
					{label: 'Malta', value: 'Malta'},
					{label: 'Marshall Islands', value: 'Marshall Islands'},
					{label: 'Martinique', value: 'Martinique'},
					{label: 'Mauritania', value: 'Mauritania'},
					{label: 'Mauritius', value: 'Mauritius'},
					{label: 'Mayotte', value: 'Mayotte'},
					{label: 'Mexico', value: 'Mexico'},
					{label: 'Micronesia', value: 'Micronesia'},
					{label: 'Moldova', value: 'Moldova'},
					{label: 'Monaco', value: 'Monaco'},
					{label: 'Mongolia', value: 'Mongolia'},
					{label: 'Montenegro', value: 'Montenegro'},
					{label: 'Montserrat', value: 'Montserrat'},
					{label: 'Morocco', value: 'Morocco'},
					{label: 'Mozambique', value: 'Mozambique'},
					{label: 'Myanmar', value: 'Myanmar'},
					{label: 'Namibia', value: 'Namibia'},
					{label: 'Nauru', value: 'Nauru'},
					{label: 'Nepal', value: 'Nepal'},
					{label: 'Netherlands', value: 'Netherlands'},
					{label: 'Netherlands Antilles', value: 'Netherlands Antilles'},
					{label: 'New Caledonia', value: 'New Caledonia'},
					{label: 'New Zealand', value: 'New Zealand'},
					{label: 'Nicaragua', value: 'Nicaragua'},
					{label: 'Niger', value: 'Niger'},
					{label: 'Nigeria', value: 'Nigeria'},
					{label: 'Niue', value: 'Niue'},
					{label: 'Norfolk Island', value: 'Norfolk Island'},
					{label: 'Northern Mariana Islands', value: 'Northern Mariana Islands'},
					{label: 'Norway', value: 'Norway'},
					{label: 'Oman', value: 'Oman'},
					{label: 'Pakistan', value: 'Pakistan'},
					{label: 'Palau', value: 'Palau'},
					{label: 'Palestine', value: 'Palestine'},
					{label: 'Panama', value: 'Panama'},
					{label: 'Paraguay', value: 'Paraguay'},
					{label: 'Peru', value: 'Peru'},
					{label: 'Philippines', value: 'Philippines'},
					{label: 'Pitcairn', value: 'Pitcairn'},
					{label: 'Poland', value: 'Poland'},
					{label: 'Portugal', value: 'Portugal'},
					{label: 'Puerto Rico', value: 'Puerto Rico'},
					{label: 'Qatar', value: 'Qatar'},
					{label: 'Romania', value: 'Romania'},
					{label: 'Russia', value: 'Russia'},
					{label: 'Rwanda', value: 'Rwanda'},
					{label: 'Réunion', value: 'Réunion'},
					{label: 'Saint Barthélemy', value: 'Saint Barthélemy'},
					{label: 'Saint Helena', value: 'Saint Helena'},
					{label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis'},
					{label: 'Saint Lucia', value: 'Saint Lucia'},
					{label: 'Saint Martin', value: 'Saint Martin'},
					{label: 'Saint Pierre and Miquelon', value: 'Saint Pierre and Miquelon'},
					{label: 'Saint Vincent and the Grenadines', value: 'Saint Vincent and the Grenadines'},
					{label: 'Samoa', value: 'Samoa'},
					{label: 'San Marino', value: 'San Marino'},
					{label: 'Saudi Arabia', value: 'Saudi Arabia'},
					{label: 'Senegal', value: 'Senegal'},
					{label: 'Serbia', value: 'Serbia'},
					{label: 'Seychelles', value: 'Seychelles'},
					{label: 'Sierra Leone', value: 'Sierra Leone'},
					{label: 'Singapore', value: 'Singapore'},
					{label: 'Sint Maarten', value: 'Sint Maarten'},
					{label: 'Slovakia', value: 'Slovakia'},
					{label: 'Slovenia', value: 'Slovenia'},
					{label: 'Solomon Islands', value: 'Solomon Islands'},
					{label: 'Somalia', value: 'Somalia'},
					{label: 'South Africa', value: 'South Africa'},
					{label: 'South Georgia and the South Sandwich Islands', value: 'South Georgia and the South Sandwich Islands'},
					{label: 'South Sudan', value: 'South Sudan'},
					{label: 'Spain', value: 'Spain'},
					{label: 'Sri Lanka', value: 'Sri Lanka'},
					{label: 'Sudan', value: 'Sudan'},
					{label: 'Suriname', value: 'Suriname'},
					{label: 'Svalbard and Jan Mayen', value: 'Svalbard and Jan Mayen'},
					{label: 'Swaziland', value: 'Swaziland'},
					{label: 'Sweden', value: 'Sweden'},
					{label: 'Switzerland', value: 'Switzerland'},
					{label: 'São Tomé and Príncipe', value: 'São Tomé and Príncipe'},
					{label: 'Taiwan', value: 'Taiwan'},
					{label: 'Tajikistan', value: 'Tajikistan'},
					{label: 'Tanzania', value: 'Tanzania'},
					{label: 'Thailand', value: 'Thailand'},
					{label: 'Togo', value: 'Togo'},
					{label: 'Tokelau', value: 'Tokelau'},
					{label: 'Tonga', value: 'Tonga'},
					{label: 'Trinidad and Tobago', value: 'Trinidad and Tobago'},
					{label: 'Tunisia', value: 'Tunisia'},
					{label: 'Turkey', value: 'Turkey'},
					{label: 'Turkmenistan', value: 'Turkmenistan'},
					{label: 'Turks and Caicos Islands', value: 'Turks and Caicos Islands'},
					{label: 'Tuvalu', value: 'Tuvalu'},
					{label: 'Ukraine', value: 'Ukraine'},
					{label: 'United Arab Emirates', value: 'United Arab Emirates'},
					{label: 'United Kingdom', value: 'United Kingdom'},
					{label: 'United States Minor Outlying Islands', value: 'United States Minor Outlying Islands'},
					{label: 'United States of America', value: 'United States of America'},
					{label: 'Uruguay', value: 'Uruguay'},
					{label: 'Uzbekistan', value: 'Uzbekistan'},
					{label: 'Vatican City', value: 'Vatican City'},
					{label: 'Venezuela', value: 'Venezuela'},
					{label: 'Vietnam', value: 'Vietnam'},
					{label: 'Virgin Islands of the United States', value: 'Virgin Islands of the United States'},
					{label: 'Wallis and Futuna', value: 'Wallis and Futuna'},
					{label: 'Western Sahara', value: 'Western Sahara'},
					{label: 'Zambia', value: 'Zambia'},
					{label: 'Zimbabwe', value: 'Zimbabwe'},
					{label: 'Åland Islands', value: 'Åland Islands'},
				],
                proofOfPermanentAddressSelect:[
					 {label: this.$t('kyc.proofOfPermanentAddressSelect.telephoneBill'), value: 'TELEPHONEBILL' },
					 {label: this.$t('kyc.proofOfPermanentAddressSelect.bankAccountStatement'), value: 'BANKACCOUNTSTATEMENT' },
					 {label: this.$t('kyc.proofOfPermanentAddressSelect.utilityBill'), value: "UTILITYBILL" },
				],
				//问题校验规则
                identityRules: [
                    v => !!v || this.$t('kyc.rules.required.identity')
                ],
				countryRules:[
					v => !!v || this.$t('kyc.rules.required.country')
				],
				proofOfPermanentAddressRules:[
					v => !!v || this.$t('kyc.rules.required.proof')
				]
            }
        },
        computed: {
        	...mapGetters([ "user" ]),
        },
        created(){
            
        },
        mounted(){

        },
        watch:{
        	birthdayFormatted(newVal, oldVal){
        		this.kycForm.birthday = this.formatBirthday(newVal);
        	}
        },        
        methods: {
        	documentImageFrontBeforeUpload(file){
        		this.isShowDocumentImageFrontUploading = true;
        		this.documentImageFrontFile = file;
                let uploadKycFileApi = config.baseUrl + 'userKyc/uploadKycFile?type=document-image-front';
                var fileData = new FormData();
                fileData.append('upfile', file);
                this.$http.post(uploadKycFileApi, fileData).then(response => {
                	let data = response.data;
                	this.isShowDocumentImageFrontUploading = false;
                	if (data.resCode == 0) {
                		this.documentImageFrontUrl = data.result;
                		this.kycForm.documentImageFrontUrl = data.result;
                	} else {
                		this.$Message.error(this.$t("common.fail"));
                	}
                }, error => {
                	this.$Message.error(this.$t("common.serverError"));
                	this.isShowDocumentImageFrontUploading = false;
                });
        	},
        	documentImageBackBeforeUpload(file){
        		this.isShowDocumentImageBackUploading = true;
        		this.documentImageBackFile = file;
                let uploadKycFileApi = config.baseUrl + 'userKyc/uploadKycFile?type=document-image-back';
                var fileData = new FormData();
                fileData.append('upfile', file);
                this.$http.post(uploadKycFileApi, fileData).then(response => {
                	let data = response.data;
                	this.isShowDocumentImageBackUploading = false;
                	if (data.resCode == 0) {
                		this.documentImageBackUrl = data.result;
                		this.kycForm.documentImageBackUrl = data.result;
                	} else {
                		this.$Message.error(this.$t("common.fail"));
                	}
                }, error => {
                	this.$Message.error(this.$t("common.serverError"));
                	this.isShowDocumentImageBackUploading = false;
                });
        	},
        	proofImageBeforeUpload(file){
        		this.isShowProofImageUploading = true;
        		this.proofImageFile = file;
                let uploadKycFileApi = config.baseUrl + 'userKyc/uploadKycFile?type=proof-image';
                var fileData = new FormData();
                fileData.append('upfile', file);
                this.$http.post(uploadKycFileApi, fileData).then(response => {
                	let data = response.data;
                	this.isShowProofImageUploading = false;
                	if (data.resCode == 0) {
                		this.proofImageUrl = data.result;
                		this.kycForm.proofImageUrl = data.result;
                	} else {
                		this.$Message.error(this.$t("common.fail"));
                	}
                }, error => {
                	this.$Message.error(this.$t("common.serverError"));
                	this.isShowProofImageUploading = false;
                });
        	},
        	selfieImageBeforeUpload(file){
        		this.isSelfieImageUploading = true;
        		this.selfieImageFile = file;
                let uploadKycFileApi = config.baseUrl + 'userKyc/uploadKycFile?type=selfie-image';
                var fileData = new FormData();
                fileData.append('upfile', file);
                this.$http.post(uploadKycFileApi, fileData).then(response => {
                	let data = response.data;
                	this.isSelfieImageUploading = false;
                	if (data.resCode == 0) {
                		this.selfieImageUrl = data.result;
                		this.kycForm.selfieImageUrl = data.result;
                	} else {
                		this.$Message.error(this.$t("common.fail"));
                	}
                }, error => {
                	this.$Message.error(this.$t("common.serverError"));
                	this.isSelfieImageUploading = false;
                });
        	},
        	// 清除证件照正面文件
        	clearDocumentImageFrontFile(){
        		this.documentImageFrontFile = null;
        		this.documentImageFrontUrl = null;
        		this.kycForm.documentImageFrontUrl = null;
        	},
        	// 清除证件照背面文件
        	clearDocumentImageBackFile(){
        		this.documentImageBackFile = null;
        		this.documentImageBackUrl = null;
        		this.kycForm.documentImageBackUrl = null;
        	},
        	// 清除证明文件
        	clearProofImageFile(){
        		this.proofImageFile = null;
        		this.proofImageUrl = null;
        		this.kycForm.proofImageUrl = null;
        	},
        	// 清除自拍文件
        	clearSelfieImageFile(){
        		this.selfieImageFile = null;
        		this.selfieImageUrl = null;
        		this.kycForm.selfieImageUrl = null;
        	},
            //上传之前的函数
            beforeUpload(file){
                let fileName = file.name;
                let suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase();
                if (suffix == "jpg" || suffix == "jpeg" || suffix == "png") {
                    //格式正确,判断大小在1M以内
                    let fileSize = file.size;
                    if (fileSize > 1024 * 1024 * 2) {
                        //文件太大
                        this.file = null;
                        this.$Message.error({
                            content: this.$t('uploadMaterial.message.tooLarge'),
                            duration:5,
                            closable: true
                        });
                    } else {
                        this.file = file;
                    }
                } else {
                    this.file = null;
                    //格式错误
                    this.$Message.error({
                        content: this.$t('uploadMaterial.message.formatIncorrect'),
                        duration:5,
                        closable: true
                    });
                }
                //return false表示不自动上传
                return false;
            },
            //清除文件
            clearFile(){
                this.clearDocumentImageFrontFile();
                this.clearDocumentImageBackFile();
                this.clearProofImageFile();
                this.clearSelfieImageFile();
            },
            //上传文件
            uploadFile(){
            	alert("正在开发中...");
            	return;
                this.uploadLoading = true;
                let url = config.baseUrl + "request/open/uploadFile/" + this.userRequest.userRequestId;
                // let url = config.baseUrl + "userDetail/open/uploadToFTPServer?userId=1234567890";
                var fileData = new FormData();
                fileData.append('upfile', this.file);//upfile是键，file是值，就是要传的文件
                this.$http.post(url, fileData).then(successData => {
                    this.uploadLoading = false;
                    this.clearFile();
                    let data = successData.data;
                    if (data.resCode == 0) {
                        //上传成功,发送通知邮件，显示通知
                        this.sendNoticeEmail();
                        this.$Notice.success({
                            title: this.$t('uploadMaterial.message.uploadSuccessTitle'),
                            duration: 10,
                            desc: this.$t('uploadMaterial.message.uploadSuccessDesc')
                        });
                        this.$router.push({name: "home"});
                    }else{
                        this.$Message.error(this.$t("common.fail"));
                    }
                }, error => {
                    this.$Message.error(this.$t("common.fail"));
                    this.uploadLoading = false;
                });
            },
            //发送通知邮件
            sendNoticeEmail(){
                let url = config.baseUrl + "sendEmail/open/sendUploadMaterialNoticeEmail?userRequestId=" + this.userRequest.userRequestId;
                this.$http.get(url).then(response => {
                    
                });
            },
            // 格式化日期
            formatBirthday (date) {
		        if (!date) return null
		        const [year, month, day] = date.split('-')
		        return `${year}${month}${day}`
			},
            // 提交表单
            submitUserKycHandle(){
            	this.submitLoading = true;
            	if (this.$refs.kycForm.validate()) {
            		if (this.kycForm.birthday == null || this.kycForm.documentImageFrontUrl == null || this.kycForm.documentImageBackUrl == null || this.kycForm.proofImageUrl == null || this.kycForm.selfieImageUrl == null) {
            			//没有通过表单验证
				    	this.$Message.error(this.$t("common.fail"));
				    	this.submitLoading = false;
				    	return;
            		}
            		let api = config.baseUrl + "userKyc/saveUserKyc";
            		this.$http.post(api, this.kycForm).then( response => {
            			this.submitLoading = false;
            			let data = response.data;
            			if (data.resCode == 0) {
            				// 提交成功,进行通知
            				this.$refs.kycForm.reset();
            				this.clearFile();
		                    this.$Notice.success({
		                      title: this.$t('common.success'),
		                      duration:5
		                    });
		                    this.$router.push({name: 'userSetting'});
            			} else {
            				this.$Message.error(this.$t("common.fail"));
            			}
            		}, error => {
            			// 服务器错误
				    	this.$Message.error(this.$t("common.serverError"));
				    	this.submitLoading = false;
            		});
            	}else{
			    	//没有通过表单验证
			    	this.$Message.error(this.$t("common.fail"));
			    	this.submitLoading = false;
			    }
            },
        },

    }
</script>


// WEBPACK FOOTER //
// UserKyc.vue?6914fc20